import React, { useEffect, useState } from "react";
import { axiosRequest } from "../../../api";
import { baseURL } from "../../../constant";
import ReactHtmlParser from "react-html-parser";

function SecurityInfomartion(){
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCmsPage = async () => {
            try {
                const response = await axiosRequest.get(`${baseURL}/getCmsPage/security-information`);
                const cmsPage = response.data || null;
                setPage(cmsPage);

                if (cmsPage?.meta_title || cmsPage?.title) {
                    document.title = cmsPage.meta_title || cmsPage.title;
                }
            } catch (error) {
                setPage(null);
            } finally {
                setLoading(false);
            }
        };

        loadCmsPage();
    }, []);

    return(
        <>
          <section className="inner-page section-themebg">
              <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h3>{page?.title || "Security Information"}</h3>
                    </div>
                </div>
              </div>
         </section>

         <section className="section-padding inner-content">
              <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-9 col-sm-12 col-12">
                        {loading && <p>Loading...</p>}
                        {!loading && page && (
                            <>
                                <h3>{page.title}</h3>
                                {ReactHtmlParser(page.description || "")}
                            </>
                        )}
                        {!loading && !page && (
                            <p>Security Information content is not available.</p>
                        )}
                    </div>
                </div>
              </div>
         </section>
        </>
    );
}
export default SecurityInfomartion;
